import React, { useEffect, useRef, useState } from 'react';
import Icon from './icons';
import { searchCompanies, TmCompany } from './api';

export interface SwapState {
  ref: string;
  coId: string;
  name: string;
  bizno: string;
  rep: string;
  tel: string;
  companyId: string | null;
}

interface Props {
  swap: SwapState;
  onChange: (patch: Partial<SwapState>) => void;
  onApply: () => void;
  onClose: () => void;
}

export default function SwapModal({ swap, onChange, onApply, onClose }: Props) {
  const [results, setResults] = useState<TmCompany[]>([]);
  const [open, setOpen] = useState(false);
  const timer = useRef<number | null>(null);

  useEffect(() => () => { if (timer.current) window.clearTimeout(timer.current); }, []);

  useEffect(() => {
    const k = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', k);
    return () => window.removeEventListener('keydown', k);
  }, [onClose]);

  const onName = (v: string) => {
    onChange({ name: v, companyId: null });
    if (timer.current) window.clearTimeout(timer.current);
    if (!v.trim()) { setResults([]); setOpen(false); return; }
    timer.current = window.setTimeout(async () => {
      try {
        const rows = await searchCompanies(v.trim());
        setResults(rows);
        setOpen(rows.length > 0);
      } catch {
        setResults([]); setOpen(false);
      }
    }, 250);
  };
  const pick = (co: TmCompany) => {
    onChange({ name: co.name, bizno: co.biz_no || '', companyId: co.id, rep: swap.rep || co.ceo || '', tel: swap.tel || co.ceo_phone || '' });
    setResults([]); setOpen(false);
  };

  return (
    <div className="ovm">
      <div className="ovbox">
        <div className="ovh"><b>🔁 투자법인 교체</b><button className="povx" onClick={onClose}><Icon n="x" /></button></div>
        <div className="ovwarn">교체하면 이 투자법인과 대표(LP)의 기존 제출자료가 초기화되고, 새 정보로 일괄 갱신됩니다.</div>
        <div className="ovfields">
          <div className="mf">
            <label>새 투자법인 명칭</label>
            <div className="cosearch">
              <input value={swap.name} autoComplete="off" onChange={(e) => onName(e.target.value)} onFocus={() => setOpen(results.length > 0)} placeholder="(주)○○ · 입력하면 기존 업체 검색" />
              <div className={'codrop ' + (open ? 'show' : '')}>
                {results.map((co) => (
                  <div className="dropitem" key={co.id} onMouseDown={() => pick(co)}>
                    <b>{co.name}</b>
                    <span className="meta">{co.biz_no || '사업자번호 없음'}{co.ceo ? ' · ' + co.ceo : ''}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="mf"><label>새 법인 사업자등록번호</label><input value={swap.bizno} onChange={(e) => onChange({ bizno: e.target.value })} placeholder="000-00-00000" /></div>
          <div className="mf"><label>새 대표자(=LP) 성명</label><input value={swap.rep} onChange={(e) => onChange({ rep: e.target.value })} placeholder="홍길동" /></div>
          <div className="mf"><label>새 대표 휴대폰</label><input value={swap.tel} onChange={(e) => onChange({ tel: e.target.value })} placeholder="010-0000-0000" /></div>
        </div>
        {swap.companyId ? (
          <div className="alert blue" style={{ marginBottom: 10 }}>
            <Icon n="info" />
            <div><b>기존 업체 선택됨</b><span> 적용 시 이 프로젝트의 투자법인으로 업무관리 업체와 연동됩니다.</span></div>
          </div>
        ) : null}
        <div className="snote" style={{ margin: '8px 0 2px' }}>⚠ 적용하면 이 당사자에게 받은 기존 제출자료 연동이 초기화되어 다시 요청해야 합니다.</div>
        <button className="sendbtn" onClick={onApply}>🔁 교체 적용 (일괄 갱신)</button>
      </div>
    </div>
  );
}
